export const selectCurrentUser = state => state.userState.user;
